export const CREATIVE_LIBRARY_REPORT_ID = 'creative-library';
